import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
export const FiltersMenu = /*#__PURE__*/ memo((param)=>{
    let { trigger, options } = param;
    return /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
        title: "Select filter",
        options: options,
        trigger: trigger
    });
});
FiltersMenu.displayName = "FiltersMenu";
